import { Component } from '@angular/core';

@Component({
  selector: 'usucampeao-projeto-atendendo-devolutivas-prefeitura',
  templateUrl: './projeto-atendendo-devolutivas-prefeitura.component.html',
  styleUrls: ['./projeto-atendendo-devolutivas-prefeitura.component.scss'],
})
export class ProjetoAtendendoDevolutivasPrefeituraComponent { }
